<form
  [formGroup]="auth_mfa_form_group"
  class="sp-column sp-form__standalone sp-padding__x4">
  <div class="sp-color__accent-contrast sp-margin__bottom sp-text__s">
    <label>{{ 'GENERAL.OTP_LABEL' | translate }}</label>
  </div>
  <div class="sp-row__justify sp-row__space sp-margin__bottom-x2 sp-wrap">
    <mat-form-field
      class="sp-form-field sp-form-field__otp sp-form-field__accent-dark sp-margin__bottom-x2 sp-form__with-border-contrast"
      appearance="fill"
      color="accent"
      [floatLabel]="'always'"
      *ngFor="let control of getFormGroupControls(); let i = index">
      <input
        matInput
        class="sp-text__center"
        inputmode="numeric"
        [maxlength]="i === 0 ? 6 : 1"
        #otp
        formControlName="otp_{{ i }}"
        [attr.autocomplete]="i === 0 ? 'one-time-code' : 'off'"
        [errorStateMatcher]="error_matcher"
        (input)="onMoveToNext($event, i)"
        (keydown)="onMoveToPrev($event, i)"
        (focus)="onSetActiveInput(i)"
        (paste)="onPasteOtp($event, i)"
        required />
    </mat-form-field>
  </div>

  <app-shared-button
    class="sp-width__full sp-margin__top-x2"
    [button_class]="'sp-button__secondary'"
    [spinner_class]="'sp-spinner__secondary'"
    [cta]="'AUTH.VERIFY_MFA'"
    [is_disabled]="!isFormValid() || is_auth_mfa_running"
    [is_spinner_visible]="is_auth_mfa_running"
    (click)="onVerifyClick()"></app-shared-button>
</form>
